import StyledCheckbox from "./StyledCheckbox";

export default StyledCheckbox;
